// src/pages/Integrations/ApiKeyModal.tsx
import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input } from "reactstrap";

interface Props {
  show: boolean;
  appName: string;
  onClose: () => void;
  onSubmit: (apiKey: string, apiSecret: string) => void;
}

const ApiKeyModal: React.FC<Props> = ({ show, appName, onClose, onSubmit }) => {
  const [apiKey, setApiKey] = useState("");
  const [apiSecret, setApiSecret] = useState("");

  return (
    <Modal isOpen={show} centered backdrop="static">
      <ModalHeader toggle={onClose}>
        Enter API Key for {appName}
      </ModalHeader>
      <ModalBody>
        <Form onSubmit={e => { e.preventDefault(); onSubmit(apiKey, apiSecret); }}>
          <FormGroup>
            <Label for="apiKey">API Key</Label>
            <Input
              id="apiKey"
              value={apiKey}
              onChange={e => setApiKey(e.target.value)}
              required
            />
          </FormGroup>
          <FormGroup>
            <Label for="apiSecret">API Secret</Label>
            <Input
              id="apiSecret"
              value={apiSecret}
              onChange={e => setApiSecret(e.target.value)}
              required
            />
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button outline onClick={onClose}>Cancel</Button>
        <Button color="primary" onClick={() => onSubmit(apiKey, apiSecret)}>
          Save
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ApiKeyModal;
